import { render, staticRenderFns } from "./VCurrencyDetail.vue?vue&type=template&id=f97deb82&scoped=true&"
import script from "./VCurrencyDetail.vue?vue&type=script&lang=js&"
export * from "./VCurrencyDetail.vue?vue&type=script&lang=js&"
import style0 from "./VCurrencyDetail.vue?vue&type=style&index=0&id=f97deb82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97deb82",
  null
  
)

export default component.exports